import React, { Fragment } from 'react';
import * as R from 'ramda';
import * as PropTypes from 'prop-types';

import Comment from './comment';
import { SvgIcon } from '../svg-icon';
import { ReactQuillWrapped } from '../react-quill';

import {
  DividerS,
  AddButton,
  Placeholder,
  CommentField,
  ButtonWrapper,
} from './styles';

const CommentsList = ({
  data,
  onSave,
  comments,
  onTextChange,
  ...rest
}) => (
  <Fragment>
    <CommentField>
      <ButtonWrapper>
        <AddButton
          type="submit"
          onClick={onSave}
          disabled={R.isEmpty(data.innerText.trim())}
        >
          <SvgIcon type="send" isWithoutHover />
        </AddButton>
      </ButtonWrapper>
      <ReactQuillWrapped
        value={data.innerHTML}
        withPaddings
        theme="snow"
        bounds="#text"
        withRightIndent
        onChange={onTextChange}
        scrollingContainer="#text"
        placeholder="Type your comment here..."
      />
    </CommentField>
    {!comments.length && <Placeholder>No comments yet...</Placeholder>}
    {comments.map((comment, index) =>
      (<Fragment key={comment._id}>
        <Comment
          {...rest}
          {...comment}
          number={index + 1}
        />
        {index < comments.length - 1 && <DividerS />}
      </Fragment>))}
  </Fragment>
);

CommentsList.propTypes = {
  comments: PropTypes.array,
  data: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  onTextChange: PropTypes.func.isRequired,
};

CommentsList.defaultProps = {
  comments: [],
};

export default CommentsList;



// WEBPACK FOOTER //
// ./src/components/comments-list/index.js